import { getTrackingValues } from 'shared/tracking/trackingUtils';
import { buildConditionalStateId, isTruthy } from 'shared/utils';
export const categorizeVideoType = (url) => {
    const a = document.createElement('a');
    a.href = url;
    const fileType = a.pathname.match(/.*\.(.*)$/);
    const isHLS = fileType && ['m3u8', 'mp4'].indexOf(fileType[1]) !== -1;
    if (isHLS) {
        return 'HLS';
    }
    return 'VAST/VPAID';
};
/**
 * Collect all video configs from ad
 */
export const collectVideoData = (ad, layoutId) => {
    const videoSymbols = Object.keys(ad.symbols)
        .map(symKey => ad.symbols[symKey])
        .filter(sym => sym.type === 'video');
    return videoSymbols.reduce((carrier, symbol) => {
        const conditionalStateId = buildConditionalStateId(symbol.id, layoutId);
        const conditionalState = ad.conditionalStates[conditionalStateId];
        // filter out only videos for the current layout
        if (!conditionalState || !conditionalState.visible) {
            return carrier;
        }
        const config = pickCorrectConfig(Object.assign(Object.assign({}, conditionalState.attributes), { symbolId: symbol.id }));
        return carrier.concat(config);
    }, []);
};
/**
 * Select correct config. Have paramount config overwrites over in-app config
 */
export const pickCorrectConfig = (config) => {
    const trackingConfigs = getTrackingValues('video', config.symbolId);
    if (trackingConfigs.length === 0) {
        return config;
    }
    // only `videoUrl` falls back, the rest of tracking should not.
    const videoUrlOverride = trackingConfigs.map(c => c.videoId).find(isTruthy);
    const videoUrl = videoUrlOverride || config.videoUrl;
    return Object.assign(Object.assign({}, config), { videoUrl });
};
